<template>
  <div class="main-product__details">
    <h1
      id="template-title"
      class="
        main-product__title
        text-heading-xl
        text-heading-2xl-desktop
      "
      v-text="product.title || liquid.title"
    />
    
    <div class="main-product__meta">
      <p
        class="main-product__sku text-body-xs-regular"
        v-text="sku"
      />
      <product-rating
        :sku="variantSkus"
        @click="handleClick"
      />
    </div>

    <product-prices
      v-if="product.type !== 'sawmill'"
      class-price="text-heading-l lon"
      :available="variant.available"
      :compare-at-price="variant.compareAtPrice?.amount"
      :price="variant.price?.amount || liquid.selectedOrFirstAvailableVariant?.price?.amount"
      :varies="variant.price?.varies || liquid.selectedOrFirstAvailableVariant?.price?.varies"
      :affirm=true
    />
    <div
      class="main-product__description text-body-s-regular rte"
      v-html="liquid.description || product.navigationDescription || liquid.navigationDescription"
    />

   

    <product-prices
      v-if="product.type === 'sawmill'"
      class="main-product__prices-container"
      class-price="text-heading-l"
      :available="variant.available"
      :compare-at-price="varprice.compareAtPrice?.amount"
      :price="varprice.price?.amount || liquid.selectedOrFirstAvailableVariant?.price?.amount"
      :varies="varprice.price?.varies || liquid.selectedOrFirstAvailableVariant?.price?.varies"
      :affirm=true
    />

    <p
      v-if="product.disclaimer"
      class="main-product__disclaimer text-body-xs-regular"
      v-text="product.disclaimer"
    />

  <p v-if="currentCountry == 'US' || currentCountry == 'CA'">
    <p
      v-if="product.specialMessaging"
      class="main-product__badge product-badge text-other-label-s"
      v-text="product.specialMessaging"
    />
  </p>
    <div
      v-if="product.included || product.type === 'sawmill'"
      class="main-product__accordions"
    >
      <div class="main-product__accordion">
        <btn
          class="main-product__accordion-button"
          class-label="main-product__accordion-label text-heading-m"
          :label="$string('product.sidebar.specs')"
          modifiers="text"
          @click="toggleAccordion($string('product.sidebar.specs'))"
        >
          <template #icon>
            <icon-minus v-if="isActive($string('product.sidebar.specs'))" />

            <icon-plus v-else />
          </template>
        </btn>

        <transition-height>
          <div
            v-show="isActive($string('product.sidebar.specs'))"
            class="main-product__accordion-content text-body-s-regular"
          >
            <div class="main-product__sidebar-specs">
              <product-stat
                :label="$string('compare.log_diameter')"
                :value="product.logDiameter"
                :unit="$string('compare.log_diameter_unit')"
              >
                <template #icon>
                  <diameter />
                </template>
              </product-stat>

              <product-stat
                :label="$string('compare.width_of_cut')"
                :value="product.widthOfCut"
                :unit="$string('compare.width_of_cut_unit')"
              >
                <template #icon>
                  <width />
                </template>
              </product-stat>
            </div>
            <div class="main-product__sidebar-specs">
              <product-stat
                :label="$string('compare.max_horsepower')"
                :value="product.maxHorsepower"
                :unit="$string('compare.max_horsepower_unit')"
              >
                <template #icon>
                  <power />
                </template>
              </product-stat>

              <product-range
                :label="$string('compare.customizability')"
                :value="product.customizability"
              >
                <template #icon>
                  <icon-customizability />
                </template>
              </product-range>
            </div>
          </div>
        </transition-height>
      </div>

      <div
        v-if="product.included !== ''"
        class="main-product__accordion"
      >
        <btn
          class="main-product__accordion-button"
          class-label="main-product__accordion-label text-heading-m"
          :label="$string('product.sidebar.included')"
          modifiers="text"
          @click="toggleAccordion($string('product.sidebar.included'))"
        >
          <template #icon>
            <icon-minus v-if="isActive($string('product.sidebar.included'))" />

            <icon-plus v-else />
          </template>
        </btn>

        <transition-height>
          <div
            v-show="isActive($string('product.sidebar.included'))"
            class="main-product__accordion-content text-body-s-regular"
            v-html="product.included"
          />
        </transition-height>
      </div>
    </div>
  </div>
</template>

<script>
import ProductPrices from '~global/product-prices/product-prices'
import ProductRating from '~async/product-rating/product-rating'
import TransitionHeight from '~async/transition-height/transition-height'
import Btn from '~global/btn/btn'
import IconMinus from '~icons/directional-navigation/minus.svg'
import IconPlus from '~icons/directional-navigation/plus.svg'
import ProductStat from '~global/product-stat/product-stat'
import ProductRange from '~global/product-range/product-range'
import Diameter from '~icons/spec/diameter.svg'
import Power from '~icons/spec/power.svg'
import Width from '~icons/spec/width.svg'
import IconCustomizability from '~icons/spec/customizability.svg'

export default {
  name: 'MainProductSidebarDetails',
  components: {
    ProductPrices,
    ProductRating,
    TransitionHeight,
    Btn,
    IconMinus,
    IconPlus,
    ProductStat,
    ProductRange,
    Diameter,
    Power,
    Width,
    IconCustomizability,
  },
  props: {
    liquid: {
      type: Object,
      default: () => ({
        description: '',
        price: 0,
        title: '',
      }),
    },
    product: {
      type: [Boolean, Object],
      default: false,
    },
    variant: {
      type: [Boolean, Object],
      default: false,
    },
  },

  emits: {
    'scroll-to-view': () => true,
  },

  data() {
    return {
      activeAccordion: null,
      currentCountry: `${cnvs.store.country}`,
    }
  },

  computed: {
    sku() {
      return `SKU: ${this.variant.sku}`
    },
    varprice(){
      let varprice = this.liquid.variants
      .filter(variant => 
          // Check if exclusiveMarket exists and includes the current country
          !variant.exclusiveMarket || 
          variant.exclusiveMarket.length === 0 ||
          variant.exclusiveMarket.includes(this.currentCountry)
      )
          .sort((a, b) => a.price.amount - b.price.amount);

      return varprice.length > 0 ? varprice[0] : null;
    },
    compatibilityList() {
      if (!this.liquid.compatibility) {
        return
      }

      const compatibilityList = this.liquid.compatibility.split('|').map((item) => item.trim())
      return compatibilityList
    },
   

    variantSkus() {
      if (!this.liquid) {
        return ''
      }

      const sku = this.liquid.variants.map((variant) => variant.sku)
      return sku.join(';')
    },
  },

  mounted() {
   console.log('variant',this.liquid.variants)

   let varprice = this.liquid.variants.map((variant) => variant )
 
  },

  methods: {
    handleClick() {
      this.$emit('scroll-to-view')
    },

    /**
     * Check if an accordion is active.
     * @param {String} target - label of accordion.
     */
    isActive(target) {
      return this.activeAccordion === target
    },

    /**
     * Toggle active accordion.
     * @param {Number} targetIndex -  Index of an accordion.
     */
    toggleAccordion(target) {
      if (target === this.activeAccordion) {
        this.activeAccordion = null
        return
      }

      this.activeAccordion = target
    },
  },
}
</script>
